var map = {
	"./": 5233,
	"./Instrument_icon.png": 5266,
	"./Vent_icon.png": 7156,
	"./ac_icon.svg": 6405,
	"./index": 5233,
	"./index.js": 5233,
	"./kolonka_icon.svg": 664,
	"./kotel_icon.svg": 5204,
	"./obogrevatel_icon.svg": 7775,
	"./uvlazhnitel_icon.svg": 7403,
	"./vodonagrevatel_icon.svg": 1268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4055;